var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerBtnIconDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 12,
    viewBox: "0 0 44 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 2,
    fill: "#111748"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 44,
    height: 1,
    fill: "#111748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerBtnIconDark);
export default __webpack_public_path__ + "static/media/burgerBtnIconDark.f6f5315551de0e74d62d7ae58a121a70.svg";
export { ForwardRef as ReactComponent };